import * as React from "react";
import {Card} from "web-com";
import {IActiveInsuranceList} from "InsuranceV2/ActiveInsurances";
import {imageBaseUrl} from "config";
import {CC_EMAIL_ID} from "utils/variables";
import {Loading} from "web-com";
import "InsuranceV2/ActiveInsurances/ActiveInsuranceCard/styles.scss";

interface IActiveInsuranceCardProps {
    product: IActiveInsuranceList;
    downloadHandler: () => void;
    errorMsg: string;
    showError: boolean;
    isloading: boolean;
}

const ActiveInsuranceCard = (props: IActiveInsuranceCardProps) => {
    const {product} = props;

    return (
        <Card>
            <div className="card-container">
                <div className="card-inner-top">
                    <div className="product-name">
                        <span>{product.productName}</span>
                    </div>
                    <div className="product-status">
                        <span className={"status-btn"}>
                            {product.status}
                        </span>
                    </div>
                </div>
                <div className="card-inner-bottom">
                    <div className="product-details">
                        <div className="product-order-id">
                            <span>Order Id: </span>
                            <span className="text-bold">{product.orderId}</span>
                        </div>
                        <div className="product-validity">
                            <span>Validity: </span>
                            <span className="text-bold">
                                {product.validityInMonths ? `${product.validityInMonths} Months` : "Under Process"}
                            </span>
                        </div>
                        <div className="product-provider">
                            <span>Provider: </span>
                            <span className="text-bold">{product.distributorName}</span>
                        </div>
                    </div>
                    <div className="download-btn-container" onClick={props.downloadHandler}>
                        <Loading active={props.isloading}/>
                        <img src={`${imageBaseUrl}/img/icons/download.png`} alt="download"/>
                        <span className="download-text">Download Policy</span>
                    </div>
                </div>
                {props.showError && <div className="error-msg-container">
                    {props.errorMsg}
                </div>}
                <div className="claim-msg-container">
                    To claim your insurance policy please mail us at <br/>
                    <span>{CC_EMAIL_ID}</span>
                </div>
            </div>
        </Card>
    );
};

export default ActiveInsuranceCard;
